import { HModules, HCF, HLink, HUtils, CSuppense } from "@macashipo/mlib"
import {
  MyUIOne,
  MyPageOne,
  MyControlOne,
  MyFormControlOne,
  MyCardOne,
  MyTableCellOne,
  MyControlForm,
  MyIconOne
} from "./components"
import "./assets/theme-rapide.scss"
const ModuleAppRapide = {
  _key: "apprapide",
  _fnList: {},
  _config: {},
  getMyKey: () => {
    return "apprapide"
  },
  runAfterInit: HConfig => {
    window.document.body.classList.add("theme-rapide")
    HModules.initDefault(ModuleAppRapide, {
      MyUIOne,
      MyPageOne,
      MyControlOne,
      MyFormControlOne,
      MyCardOne,
      MyTableCellOne,
      MyControlForm,
      MyIconOne
    })
    CSuppense.LazyLoading = () => {
      return (
        <div className="mui-lazy-loading ani-fadeIn">
          <i className="fa fa fa-circle-o-notch fa-spin" />
        </div>
      )
    }
    // HUtils.runFuntion(HConfig, "addPrivateRoutes", [
    //   [
    //     {
    //       Id: "BS_QUOTE_ORDER_DETAIL",
    //       UIUrl: "/bs-quote-order-detail/:entnumber",
    //       UIType: "manage_quotes",
    //       Title: "Quote Order Detail",
    //     },
    //     {
    //       Id: "BS_BILL_JOB_DETAIL",
    //       UIUrl: "/bs-job-order-detail/:entnumber",
    //       UIType: "manage_job_order",
    //       Title: "Job Order Detail",
    //     },
    //   ],
    // ])
  },
}

export default ModuleAppRapide
